module.exports = __webpack_public_path__ + "media/images/season-2-podcast-a286e85215452c4f81a8a1748a193e3f.png";